module.exports = __webpack_public_path__ + "img/map.35ab2e47.png";